import axios from "axios";
import api from "./api";

/**
 * Orquestra presign → PUT S3 → confirm.
 * @param {File} file
 * @param {{ onProgress?: (pct: number) => void }} [opts]
 * @returns {Promise<{ url: string, key: string, name: string, size: number, _id: string }>}
 */
export async function uploadFile(file, { onProgress } = {}) {
  const { data: presign } = await api.post("/upload/presign", {
    filename: file.name,
    contentType: file.type,
    size: file.size,
  });

  const { uploadUrl, key, headers } = presign;

  await axios.put(uploadUrl, file, {
    headers: { ...headers },
    onUploadProgress: (progressEvent) => {
      if (typeof onProgress !== "function" || !progressEvent.total) {
        return;
      }
      const percent = Math.round(
        (progressEvent.loaded * 100) / progressEvent.total
      );
      onProgress(percent);
    },
  });

  const { data } = await api.post("/upload/confirm", {
    key,
    name: file.name,
    size: file.size,
  });

  return data;
}
